<template>
    <div class="nodata">
        <!-- <img src="@/assets/img/nodata.png"/> -->
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>


<style lang="scss" scoped>
.nodata{
    width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 50px;
	img{
		width: 250px;
		height: 250px;
	}
}
</style>